import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../../interfaces/environment.interface';
import { SystemSettings } from '../../interfaces/system-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class SystemSettingsService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public getSettings(): Observable<SystemSettings> {
    return this._http.get<SystemSettings>(`${this._baseUrl}/system-settings`);
  }
}
